import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useToast } from 'hooks/useToast';
import { useTruckerProps } from 'hooks/useTruckerProps';
import { ITruckerProfileProps } from 'interfaces/profile.interface';
import { removeContact } from 'services/contactList/remove';
import { TRUCKER_PROFILE_KEY } from '../useTruckerProfileQuery';

export const useRemoveContact = (personUuid: string, customQueryKey?: string) => {
  const { truckerId } = useTruckerProps();
  const { addToast } = useToast();
  const queryClient = useQueryClient();

  const queryKey = customQueryKey ? [customQueryKey] : [TRUCKER_PROFILE_KEY, truckerId];

  return useMutation({
    mutationFn: () => removeContact(personUuid),
    onSuccess: async () => {
      queryClient.setQueryData<ITruckerProfileProps>(queryKey, (truckerInfo: ITruckerProfileProps) => {
        const mutableObj = {
          ...truckerInfo,
          trucker: {
            ...truckerInfo?.trucker,
            inContactList: false,
          },
        };
        return { ...mutableObj };
      });
      addToast({ heading: 'Motorista removido dos seus contatos', type: 'success' });
    },
    onError: () => {
      addToast({ heading: 'Não foi possível remover o motorista dos seus contatos. Tente novamente.', type: 'error' });
    },
  });
};
